export default __webpack_public_path__ + "static/media/cgClaires35bday.572f05dd.jpg";